<template>
  <div class="edit-pass-carriage-licence">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Серия</label>
        <imask-input type="text"
          class="form-control"
          v-model="data.series"
          required
        />
      </div>
      <div class="col-md-4 mb-2">
        <label>Номер</label>
        <imask-input type="text"
          class="form-control"
          v-model="data.number"
          required
        />
      </div>
    </div>
    <hr class="mb-4" />
  </div>
</template>

<script>
const type = 'pass_carriage_licence'

export default {
  name: 'DocumentPassCarriageLicenceEdit',
  props: ['documentData'],
  data () {
    return {
      data: {
        number: '',
        series: ''
      }
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.$emit('update', {
          type: type,
          data: this.data
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .edit-licence input {
    margin-bottom: 5px;
  }
  .edit-licence textarea {
    margin-bottom: 5px;
  }
</style>
